import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Group from 'components/form/Group';
import Title from 'components/Title';
import useRouter from '../../useRouter';
import {
    getScpiSimulationEntryPoint,
    getScpiSimulationProduct,
    startSimulationTunnel,
} from '../../../utils/simulationTunnel';
import { GET } from '../../../utils/httpMethods';

const SCPISimulation = ({ recommendationCif, ripId, target, recommendationId, onSimulationChecked }) => {
    const { navigate } = useRouter();
    const recommendation = (recommendationCif || []).find(({ simulationId, type }) => simulationId && getScpiSimulationProduct({ type }));
    const product = recommendation && getScpiSimulationProduct(recommendation);
    const entryPoint = product && getScpiSimulationEntryPoint(product);
    const { simulationId } = recommendation;

    const getSimulationReturnKey = () =>
        `scpi-simulation-return-${ripId}-${simulationId}`;

    const launchSimulation = () => {
        if (!recommendation || !entryPoint) {
            return;
        }

        sessionStorage.setItem(
            getSimulationReturnKey(ripId, recommendation.simulationId),
            'true',
        );
        const recommendationUrl =
            `/rip/${ripId}/approvalCif/${target}/${recommendationId}`;
        startSimulationTunnel({
            recommendationUrl,
            simulationId: recommendation.simulationId,
            entryPoint,
            recommendationType: recommendation.type,
        });

        navigate(`/rip/${ripId}/simulations/${recommendation.simulationId}/${entryPoint}`);
    };

    useEffect(() => {
        if (recommendation && !recommendation.simulationId) {
            return;
        }

        const returnKey = getSimulationReturnKey(
            ripId,
            recommendation.simulationId,
        );

        const hasReturnedFromSimulation =
        'true' === sessionStorage.getItem(returnKey);

        if (!hasReturnedFromSimulation) {
            return;
        }

        const checkSimulationComplete = async () => {
            try {
                const response = await GET(`/api/simulations/${recommendation.simulationId}`);
                const simulationData = await response.json();

                const isComplete = 0 === simulationData.errorCount;

                onSimulationChecked(isComplete);

                sessionStorage.removeItem(returnKey);
            } catch (error) {
                console.error(error);
                onSimulationChecked(false);
            }
        };

        checkSimulationComplete();
    }, [ripId, recommendation.simulationId, onSimulationChecked]);

    return (
        <Group>
            <Title><b>La simulation SCPI</b></Title>
            <button type="button" className="theseis-btn" onClick={launchSimulation} disabled={!recommendation || !entryPoint} style={{ marginBottom: '0px' }} >
                Lancer la simulation
            </button>
        </Group>
    );
};

SCPISimulation.propTypes = {
    recommendationCif: PropTypes.arrayOf(PropTypes.shape({
        simulationId: PropTypes.string,
        type: PropTypes.string,
    })),
    ripId: PropTypes.string.isRequired,
    target: PropTypes.string.isRequired,
    recommendationId: PropTypes.string,
    onSimulationChecked: PropTypes.func,
};

SCPISimulation.defaultProps = {
    recommendationCif: [],
};

export default SCPISimulation;
